export class CharacterPlatformRequestError extends Error {
  constructor(message, { status, detail, responseBody } = {}) {
    super(message)
    this.name = "CharacterPlatformRequestError"
    this.status = typeof status === "number" ? status : undefined
    this.detail = detail ?? undefined
    this.responseBody = responseBody ?? undefined
  }
}

function detailMessage(value, fallbackMessage = "") {
  if (typeof value === "string" && value.trim()) {
    return value.trim()
  }

  if (value && typeof value === "object") {
    if (typeof value.message === "string" && value.message.trim()) {
      return value.message.trim()
    }
    try {
      return JSON.stringify(value)
    } catch {}
  }

  return fallbackMessage.trim()
}

export function normalizeResponseDetailPayload(
  payload,
  fallbackMessage = ""
) {
  const container =
    payload && typeof payload === "object" ? payload : null
  const candidate =
    container && ("detail" in container || "error" in container)
      ? (container.detail ?? container.error)
      : payload

  if (typeof candidate === "string") {
    return {
      message: detailMessage(candidate, fallbackMessage),
    }
  }

  if (candidate && typeof candidate === "object") {
    return {
      ...candidate,
      message: detailMessage(candidate, fallbackMessage),
    }
  }

  return {
    message: detailMessage(fallbackMessage, ""),
  }
}

export async function buildBackendRequestError(response, fallbackMessage) {
  const text = await response.text().catch(() => "")
  let payload = null

  if (text.trim()) {
    try {
      payload = JSON.parse(text)
    } catch {
      payload = text
    }
  }

  const detail = normalizeResponseDetailPayload(payload, fallbackMessage)
  return new CharacterPlatformRequestError(
    detail.message || fallbackMessage,
    {
      status: response.status,
      detail,
      responseBody: text,
    }
  )
}

export function getBackendErrorDetail(error, fallbackMessage = "") {
  if (error && typeof error === "object") {
    const detail = error.detail
    if (detail && typeof detail === "object") {
      return normalizeResponseDetailPayload(detail, fallbackMessage)
    }
    if (typeof detail === "string" && detail.trim()) {
      return { message: detail.trim() }
    }

    if (typeof error.message === "string" && error.message.trim()) {
      return { message: error.message.trim() }
    }
  }

  if (typeof error === "string" && error.trim()) {
    return { message: error.trim() }
  }

  return { message: fallbackMessage.trim() }
}

